export default "__VITE_ASSET__BOtildZC__"